import { IconSize } from '../Icon';
import { Language } from '../constants/languages';
export const LOADER_TRANSLATION_KEYS = {
  fallbackText: 'component.Loader.fallbackText'
};
export const LOADER_TRANSLATIONS = {
  [Language.EN]: {
    [LOADER_TRANSLATION_KEYS.fallbackText]: 'Loading...'
  },
  [Language.PL]: {
    [LOADER_TRANSLATION_KEYS.fallbackText]: 'Ładowanie...'
  },
  [Language.CS]: {
    [LOADER_TRANSLATION_KEYS.fallbackText]: 'Stránka se načítá...'
  },
  [Language.SK]: {
    [LOADER_TRANSLATION_KEYS.fallbackText]: 'Stránka sa načítava...'
  }
};
export const LoaderSize = {
  ...IconSize,
  DEFAULT: 60
};